export default "<receipt-switcher></receipt-switcher>\r\n"